import { render, staticRenderFns } from "./Clientboard.vue?vue&type=template&id=0e7493d8&"
import script from "./Clientboard.vue?vue&type=script&lang=js&"
export * from "./Clientboard.vue?vue&type=script&lang=js&"
import style0 from "./Clientboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports